<template>
<div class="container-fluid bg-white">
	<toolbar>
		<h2>
			<i class="fa fa-wrench"></i>
			Services Apps
		</h2>

		<projects-toolbar-controls 
			:is-services="true"
			:mobile-breakpoint="mobileBreakpoint">
		</projects-toolbar-controls>
	</toolbar>

	<addon-app-tab ui-location="Services Module"></addon-app-tab>
</div>
</template>
<script type="text/javascript">
import Toolbar from "@/layout_fragments/Toolbar"
import ProjectsToolbarControls from "@/pages/project/ProjectsToolbarControls"
import AddonAppTab from "@/components/AddonAppTab"

export default {
	components: {
		Toolbar,
		AddonAppTab,
		ProjectsToolbarControls
	}
}
</script>